import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RemoteControlVideoRecordingService, VideoRecordingStatus } from '../../services/video-recording.service';

@Component({
  selector: 'app-remote-control-video-recording-timer',
  templateUrl: './video-recording-timer.component.html',
  styleUrls: ['./video-recording-timer.component.scss'],
})
export class RemoteControlVideoRecordingTimerComponent implements OnInit, OnDestroy {
  private _recordedTime: number = 0;

  // Maps to whether video recording is currently running (paused = running as well)
  public get running(): boolean {
    return this.videoRecordingService?.isRecordingRunning || false;
  }

  // Represents formatted time
  public get formattedTime(): string {
    return `${this.toDoubleDigit(Math.floor(this._recordedTime / 60))}:${this.toDoubleDigit(this._recordedTime % 60)}`;
  }

  public isPaused = false;

  // Tracks component destruction to cancel all observable subscriptions
  private onDestroy = new Subject<void>();

  private intervalId: any;

  constructor(private videoRecordingService: RemoteControlVideoRecordingService, private _cdRef: ChangeDetectorRef) {
    this._recordedTime = videoRecordingService.recordedTime;
  }

  ngOnInit() {
    // we are using a getter formattedTime to display time. When there are no other changes,
    // Angular could skip timer when it doesn't detect other changes. This 1s interval
    // manually triggers change detection
    this.intervalId = setInterval(() => {
      this._recordedTime = this.videoRecordingService.recordedTime;
      this._cdRef.detectChanges();
    }, 1000);

    this.videoRecordingService.pause.pipe(takeUntil(this.onDestroy)).subscribe(paused => {
      this.isPaused = paused;
    });
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  public isVideoWithAudio = (): boolean => this.videoRecordingService.isVideoWithAudio;

  private toDoubleDigit(num: number): string {
    return num.toLocaleString(undefined, { minimumIntegerDigits: 2 });
  }
}
